import { useQuery } from '@tanstack/react-query';
import {
  getApprovalContract,
  listApprovalsContract,
  type GetApprovalResponse,
  type ListApprovalsResponse
} from '@bliks-io/contracts';
import { apiClient } from '../client';
import { approvalKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';

/** One Freigabe with the actions the caller has on it; idle while `id` is null. */
export function useApproval(id: string | null) {
  return useQuery({
    queryKey: approvalKeys.detail(id ?? ''),
    queryFn: async ({ signal }): Promise<GetApprovalResponse> => {
      const path = getApprovalContract.path.replace(':id', id ?? '');
      const { data } = await apiClient.get<GetApprovalResponse>(path, { signal });
      return data;
    },
    enabled: id !== null,
    staleTime: 0
  });
}

/** The Freigaben the caller may see: all of the workspace for admins, else their own. */
export function useApprovals() {
  const { token } = useAuthStore();
  return useQuery({
    queryKey: approvalKeys.list,
    queryFn: async ({ signal }): Promise<ListApprovalsResponse> => {
      const { data } = await apiClient.get<ListApprovalsResponse>(listApprovalsContract.path, {
        signal
      });
      return data;
    },
    enabled: !!token,
    staleTime: 0,
    refetchOnWindowFocus: true
  });
}
